/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Cloudflare_Email_Account_IdInputs */

const en_admin_settings_fields_cloudflare_email_account_id = /** @type {(inputs: Admin_Settings_Fields_Cloudflare_Email_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account ID`)
};

/**
* | output |
* | --- |
* | "Account ID" |
*
* @param {Admin_Settings_Fields_Cloudflare_Email_Account_IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_cloudflare_email_account_id = /** @type {((inputs?: Admin_Settings_Fields_Cloudflare_Email_Account_IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Cloudflare_Email_Account_IdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_cloudflare_email_account_id(inputs)
});
export { admin_settings_fields_cloudflare_email_account_id as "admin.settings.fields.cloudflare_email_account_id" }